import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";

import {
    MDBTableHead,
    MDBTableBody,
    MDBBtn,
    MDBTable,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBModal,
    MDBTooltip,
    MDBInput,
    MDBCheckbox
} from "mdb-react-ui-kit";
import {Link, useNavigate} from "react-router-dom";
import {backendPathAuth, backendPathPartners} from "../Constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faPen, faTrash} from "@fortawesome/free-solid-svg-icons";
import {InputGroup} from "react-bootstrap";
import {checkVisibility, switchVisibility} from "../functions/visibility";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";


function Partners() {
    const navigate = useNavigate();

    const [partnerList, setPartnerList] = useState([]);
    const [partnerName, setPartnerName] = useState("");
    const [partnerID, setPartnerID] = useState(0);
    const [employeeCounter, setEmployeeCounter] = useState(0);
    const [deletionPopupVisible, setDeletionPopupVisible] = useState(false);
    const [editName, setEditName] = useState(false);
    const [reload, setReload] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    const getPartners = () => {
        Axios.get(backendPathPartners+"partners-numbered.php").then((response) => {
            setPartnerList(response.data);
        });
    };

    const toggleShow = () => setDeletionPopupVisible(!deletionPopupVisible);

    const deletePartner = () => {
        Axios.get(`${backendPathPartners}delete-partner.php?id=${partnerID}`).then((response) => {
            setDeletionPopupVisible(false);
            getPartners();
        });
    };

    const updatePartnerName = (id, name) => {

        if (!partnerName) {
            return;
        }

        Axios.get(backendPathPartners+"update-partner-name.php", {
            params: {
                name: name,
                partnerId: id,
            }
        }).then(() => {
            setEditName(false);
            getPartners();
        });

    };

    useEffect(() => {
        getPartners();
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    return (
        <>
        <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

        <div className="main">
            <div className="header-above-table d-flex align-items-center">
                <h2>Liste aller Partner</h2>
                <Link className="link calendar-h" to="/new-partner">
                    <MDBBtn className="btn">hinzufügen</MDBBtn>
                </Link>
            </div>

            <MDBTable align='middle'>
                <MDBTableHead className="table-head">
                    <tr className="underlined-header">
                        <th scope='col'>Name</th>
                        <th scope='col'>aktive Kunden</th>
                        <th scope='col'>aktive Betreuungskräfte</th>
                        <th scope='col'>Sichtbar</th>
                        <th scope='col'></th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    <tr className="table-body"><td></td><td></td><td></td></tr>
                    {partnerList.map((val, key) => {
                        return (
                            <tr key={key}>
                                <td>{
                                    editName && partnerID === Number(val["PartnerID"]) ?
                                        <InputGroup className="">
                                            <MDBInput className="" label='Name' type='text' value={partnerName}
                                                      onChange={(event) => {
                                                          setPartnerName(event.target.value);
                                                      }}
                                            >
                                            </MDBInput>
                                            <MDBBtn onClick={(event) => {
                                                console.log(partnerName);
                                                updatePartnerName(val["PartnerID"], partnerName);
                                            }}>
                                                <FontAwesomeIcon className='btn-icon' icon={faCheck} />
                                            </MDBBtn>
                                        </InputGroup>
                                        :
                                        <div className="edit-partner-btn" onClick={() => {
                                            setPartnerID(Number(val["PartnerID"]));
                                            setPartnerName(val["Name"]);
                                            setEditName(true);
                                        }}>
                                            {val["Name"]}
                                            <FontAwesomeIcon className='btn-icon ms-3' icon={faPen} />
                                        </div>
                                    }
                                </td>
                                <td>{val["CustomerNumber"] ? val["CustomerNumber"] : 0}</td>
                                <td>{val["EmployeeNumber"] ? val["EmployeeNumber"] : 0}</td>
                                <td>
                                    <MDBCheckbox name='flexCheck' value='' checked={checkVisibility(val["PartnerID"], "partner")} onChange={
                                        (event) => {
                                            switchVisibility(val["PartnerID"], "partner");
                                            setReload(!reload);
                                        }
                                    }/>
                                </td>
                                <td>
                                    <MDBTooltip tag='a' wrapperProps={{  }} title="löschen">
                                        <FontAwesomeIcon className='btn-icon trash-btn' icon={faTrash} onClick={
                                            () => {
                                                setPartnerID(val["PartnerID"]);
                                                setPartnerName(val["Name"]);
                                                setEmployeeCounter(val["EmployeeNumber"]);
                                                toggleShow()
                                            }} />
                                    </MDBTooltip>

                                </td>
                            </tr>
                        );
                    })}
                </MDBTableBody>
            </MDBTable>

            <MDBModal show={deletionPopupVisible} setShow={setDeletionPopupVisible} tabIndex="-1">
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>Partner {partnerName} löschen</MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={toggleShow}
                            ></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {employeeCounter ?
                                "Wenn dieser Partner gelöscht wird, wird auch bei " + employeeCounter + " aktiven Betreuungskräften der eingetragene Partner gelöscht." :
                                "Soll dieser Partner wirklich gelöscht werden?"
                            }
                        </MDBModalBody>

                        <MDBModalFooter>
                            <MDBBtn className="btn-light" onClick={toggleShow}>
                                Abbrechen
                            </MDBBtn>
                            <MDBBtn onClick={deletePartner}>Löschen</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
        </>
    );
}

export default Partners;